<div *ngIf="isLoading">
  <app-skeleton-diary></app-skeleton-diary>
</div>

<div *ngIf="!isLoading">
  <mat-card-content>
    <div class="calendar-header d-none d-md-flex">
      <button
        id="today-button"
        mat-button
        mwlCalendarToday
        [(viewDate)]="viewDate"
      >
        {{ 'pages.diary.calendar.today' | translate }}
      </button>
      <div class="date-view" style="min-width: 280px">
        <button
          mat-icon-button
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
        >
          <mat-icon aria-label="chevron_left" style="margin-bottom: 4px"
            >chevron_left</mat-icon
          >
        </button>

        <span>{{ viewDate | calendarDate : view + 'ViewTitle' : 'en' }}</span>

        <button
          mat-icon-button
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
        >
          <mat-icon aria-label="chevron_right" style="margin-bottom: 4px"
            >chevron_right</mat-icon
          >
        </button>
      </div>
      <mat-button-toggle-group>
        <mat-button-toggle
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"
          >{{ 'pages.diary.calendar.month' | translate }}</mat-button-toggle
        >
        <mat-button-toggle
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week"
          >{{ 'pages.diary.calendar.week' | translate }}</mat-button-toggle
        >
        <mat-button-toggle
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day"
          >{{ 'pages.diary.calendar.day' | translate }}</mat-button-toggle
        >
      </mat-button-toggle-group>
    </div>
    <div class="calendar-header d-flex d-md-none">
      <button
        id="today-button"
        mat-button
        mwlCalendarToday
        [(viewDate)]="viewDate"
      >
        {{ 'pages.diary.calendar.today' | translate }}
      </button>
      <mat-button-toggle-group>
        <mat-button-toggle
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"
          >{{ 'pages.diary.calendar.month' | translate }}</mat-button-toggle
        >
        <mat-button-toggle
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week"
          >{{ 'pages.diary.calendar.week' | translate }}</mat-button-toggle
        >
        <mat-button-toggle
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day"
          >{{ 'pages.diary.calendar.day' | translate }}</mat-button-toggle
        >
      </mat-button-toggle-group>
      <div class="date-view">
        <button
          mat-icon-button
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
        >
          <mat-icon aria-label="chevron_left" style="margin-bottom: 4px"
            >chevron_left</mat-icon
          >
        </button>

        <span>{{ viewDate | calendarDate : view + 'ViewTitle' : 'en' }}</span>

        <button
          mat-icon-button
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
        >
          <mat-icon aria-label="chevron_right" style="margin-bottom: 4px"
            >chevron_right</mat-icon
          >
        </button>
      </div>
    </div>
    <br />
    <div [ngSwitch]="view">
      <mwl-calendar-month-view
        *ngSwitchCase="CalendarView.Month"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        [activeDayIsOpen]="activeDayIsOpen"
        (dayClicked)="dayClicked($event.day)"
        (eventClicked)="handleEvent('Clicked', $event.event)"
        (eventTimesChanged)="eventTimesChanged($event)"
      >
      </mwl-calendar-month-view>
      <mwl-calendar-week-view
        *ngSwitchCase="CalendarView.Week"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        (hourSegmentClicked)="clickedSlot($event)"
        (eventClicked)="handleEvent('VIEW', $event.event)"
        (eventTimesChanged)="eventTimesChanged($event)"
      >
      </mwl-calendar-week-view>
      <mwl-calendar-day-view
        *ngSwitchCase="CalendarView.Day"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        (hourSegmentClicked)="clickedSlot($event)"
        (eventClicked)="handleEvent('VIEW', $event.event)"
        (eventTimesChanged)="eventTimesChanged($event)"
      >
      </mwl-calendar-day-view>
    </div>
  </mat-card-content>
</div>
